import React from "react";

export const ChestClosed: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect x="6" y="12" width="20" height="12" rx="3" fill="#B8860B" stroke="#333" strokeWidth="2" />
    <rect x="6" y="8" width="20" height="6" rx="2" fill="#DEB887" stroke="#333" strokeWidth="2" />
    <rect x="14" y="18" width="4" height="4" rx="1" fill="#333" />
  </svg>
);

export const ChestOpen: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect x="6" y="16" width="20" height="8" rx="3" fill="#B8860B" stroke="#333" strokeWidth="2" />
    <rect x="6" y="8" width="20" height="10" rx="2" fill="#FFD700" stroke="#333" strokeWidth="2" />
    <rect x="14" y="20" width="4" height="4" rx="1" fill="#333" />
    <rect x="10" y="10" width="12" height="4" rx="1" fill="#FFF700" />
  </svg>
);